<template>
  <div class="headerTop flex_between" style="justify-content: space-between">
    <div class="leftHead flex_end">
      <img src="../../assets/logo@1x.png" alt="">
    </div>
    <div v-if="shouldShowRightHead" style="position:relative;" class="rightHead">
      <div class="home" @click="handleGoHome">
        <i class="el-icon-s-home"></i>
      </div>
      <el-badge :value="msgNum" class="item" :hidden="msgNum==0">
        <img src="../../assets/msg.png" @click="showReadList" />
      </el-badge>
      <el-dropdown @command="handleCommand">
        <el-button class="settings">
          <img :src="avatar">
<!--          <p>Settings</p>-->
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="center">Personal Center</el-dropdown-item>
          <el-dropdown-item command="Reset">Reset Password</el-dropdown-item>
          <el-dropdown-item command="MonthlyStatement">Monthly Statement</el-dropdown-item>
          <el-dropdown-item command="Logout">Logout</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-dialog
      top="72px"
      :show-close="false"
      :modal="false"
      :visible.sync="dialogVisible" width="600px" custom-class="msgdialog">
      <div slot="title" class="el-dialog__head">
          <span class="el-dialog__title">Notifications
          <el-select v-model="viewValue" @change="getFourList">
            <el-option
              v-for="item in ViewOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </span>
        <el-button @click="readAll">
          Mark all as read
          <i class="el-icon-success" style="font-size: 20px"></i>
        </el-button>
      </div>
      <span>
        <div class="ViewMsg" v-for="(item,index) in datalist" :key="index" @click="readMsg(item.id)">
<!--          <img v-if="item.is_read==0" class="dot" src="../../assets/dot.svg" />-->
          <el-badge is-dot :hidden="item.is_read!=0">
            <img src="../../assets/Initials.png" />
          </el-badge>
          <div class="infoView">
            <p v-html="item.content2"></p>

            <span>{{item.created_at_show}}</span>
          </div>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <button v-if="isShow" @click="getAllList" type="button" class="el-button el-button--primary"><span>View All</span></button>
        <p v-else>That's all your notifications from the last 30 days.</p>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import store from '@/store/store'
export default {
  data() {
    return {
      dialogVisible: false,
      ViewOptions: [{
          value: '0',
          label: 'All'
        }, {
          value: '2',
          label: 'Unread'
        }],
        viewValue: '0',
        isShow:false,
        datalist:[],
        msgNum:0,
        avatar:'../../assets/settings.png'
    };
  },
  computed: {
    shouldShowRightHead() {
      return this.$route.path != '/'
    }
  },
  watch: {
    '$route.path'(newPath) {
      this.avatar='../../assets/settings.png'
      if (newPath != '/') {
         this.$http.get('/tutor/api/getGlobalInfo?time=' + this.utils.timeZone()).then((res) => {
            if (res.data.code == 200) {
              this.avatar = res.data.data.avatar
            } else {
              this.$message({
                message: res.data.msg,
                type: 'warning'
              })
            }
          }).catch((error) => {
            console.log(error) // 请求失败返回的数据
          })
        this.fetchMsgNum()
      }
    }
  },
  created(){
    if (this.shouldShowRightHead) {
      this.fetchMsgNum()
    }
    if (this.$route.path !== '/'){
      this.$http.get('/tutor/api/getGlobalInfo?time=' + this.utils.timeZone()).then((res) => {
        if (res.data.code == 200) {
          store.setMsgNum(res.data.data.no_read_num)
          this.msgNum = res.data.data?res.data.data.no_read_num : 0
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
      this.getFourList()
    }
    if(this.dialogVisible){
      this.getFourList()
    }
  },
  mounted(){
    setTimeout(()=>{
      this.avatar = sessionStorage.getItem('avatar')
    },1000)
  },
  methods: {
    // 提取获取消息数量的方法，便于复用
    fetchMsgNum() {
      this.$http.get('/tutor/api/getGlobalInfo?time=' + this.utils.timeZone()).then((res) => {
        if (res.data.code == 200) {
          store.setMsgNum(res.data.data.no_read_num)
          this.msgNum = res.data.data?res.data.data.no_read_num : 0
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    handleGoHome() {
      this.$router.push('/index')
    },
    handleCommand (command) {
      if (command == 'Reset') {
        this.$router.push({ path: '/resetPassword' })
      } else if (command == 'Logout') {
        this.$http.get('/tutor/api/outLogin').then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.data,
              type: 'warning'
            })
            this.utils.clearCookie('pc_token')
            this.$router.push({ path: '/' })
          }
        })
      }else if(command == 'MonthlyStatement'){
        this.$router.push({ path: '/index',
            query: {
              'type': 'month_state'
          } })
      }else if(command == 'center'){
        // this.$router.push({ path: '/mine'})
        this.$router.push({ path: '/index',
            query: {
              'type': 'mine'
          } })
      }
    },
    showReadList(){
      this.dialogVisible= !this.dialogVisible;
      this.getFourList()
    },
    getFourList() {

        this.$http.get('/tutor/api/getTeacherMessage?read_status='+this.viewValue).then((res) => {
          if (res.data.code == 200) {
            if(res.data.data.total>4&&res.data.data.list.length==4){
              this.isShow = true;
            }else{
              this.isShow = false
            }
            this.datalist = res.data.data.list

            this.datalist.map(item=>{
                if (item.content && item.content.length > 0) {
                    item.content2 = ''
                    item.content.map((c,i) => {
                        if (i==1) {
                          item.content2 += `<b>${c}</b>`;
                        }else{
                          item.content2 += c
                        }
                    })
                }
            })
          }
        })
    },
    getAllList() {

        this.$http.get('/tutor/api/getTeacherMessageMore?read_status='+this.viewValue).then((res) => {
          if (res.data.code == 200) {
            this.isShow = false;
            this.datalist = [...this.datalist,...res.data.data.list]
            this.datalist.map(item=>{
                if (item.content && item.content.length > 0) {
                    item.content2 = ''
                    item.content.map((c,i) => {
                        if (i==1) {
                          item.content2 += `<b>${c}</b>`;
                        }else{
                          item.content2 += c
                        }
                    })
                }
            })
          }
        })
    },
    readMsg(id) {

        this.$http.get('/tutor/api/readTeacherMessage?id='+id).then((res) => {
          if (res.data.code == 200) {
            this.datalist.map(item=>{
              if(item.id == id){
                item.is_read = 1
              }
            })
            this.msgNum = res.data.data.no_read_num
          store.setMsgNum(this.msgNum)
            // this.getFourList()
            // if(!this.isShow){
            //   this.getAllList();
            // }
          }
        })
    },
    readAll(){
      this.$http.post('/tutor/api/readAllTeacherMessage').then((res) => {
        if (res.data.code == 200) {
          this.datalist.map(item=>{
              item.is_read = 1
          })
          this.msgNum = res.data.data.no_read_num
          store.setMsgNum(this.msgNum)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .headerTop{
    //width:1200px;
    height: 64px;
    margin:0 auto;
    font-family: Arial;
    font-size: 20px;
    color: #fff;
    .leftHead{
      margin-left: 24px;
    }
    .rightHead{
      margin-right: 24px;
      display: flex;
      align-items: center;
      img{
        height: 20x;
        width: auto;
      }
    }
    /deep/ .el-dropdown{
      .settings{
        background: none;
        border:none;
        color:#fff;
        font-size: 16px;
        padding: 0;
        span{
          display: flex;
          align-items: center;
          font-size: 16px;
          font-family: Arial;
          img{
            width:32px;
            height:32px;
            margin-right:6px;
            border: 2px solid #fff;
            border-radius: 17px;
          }
          p{
            font-size: 16px;
          }
        }

      }
    }
    .el-dialog__wrapper{
      // position: absolute;
      // top:initial;
      // bottom:initial;
      // left:initial;
      // right:initial;
      // overflow:initial;
    }
    .home {
      cursor: pointer;
      position: relative;
      vertical-align: middle;
      display: inline-block;
      margin-right:20px;
      margin-bottom: 3px;
      i {
        font-size: 28px;
      }
    }
    .item{
      margin-right:20px;
    }
    /deep/ .el-badge{
      cursor: pointer;
      .el-badge__content.is-fixed{
        border:none;
        background: #FF0000;
        //box-shadow: 0px 4px 5px rgba(255, 88, 88, 0.4);
        box-shadow: none;
      }
    }
  }
  // 设置下拉框
  /deep/ .el-dropdown-menu{
    width:180px;
    padding:6px 0;
    margin:0;
    font-family: Arial;
  }
  /deep/ .el-dropdown-menu__item{
    width:145px;
    background: #fff;
    color:#353643;
    font-size:16px;
    line-height: 40px;
    padding:0 20px;
  }
  /deep/ .popper__arrow{
    display: none;
  }
  /deep/ .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
    background: rgba(255,100,64,0.30);
    font-size: 16px;
    font-family: Arial;
    color: #ff6440;
    letter-spacing: 0px;
  }

    /deep/ .el-dialog{
      margin:0;
      width:440px;
      position: absolute;
      right: 144px;
      z-index:11;
      background: #fff;
      box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.2);
      border-radius: 4px;

      .el-dialog__header{padding:0;}
      .el-dialog__head{

        padding:12px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-dialog__title{
          font-size:14px;
          .el-select{
            // width:65px;
            max-width: 85px;
            min-width: 65px;
            font-size: 12px;
            line-height: initial;
            .el-input{
              font-size: 12px;
              .el-input__icon{
                line-height: initial;
              }
            }
            .el-input__inner{
              font-size: 12px;
              border:none;
              background: none;
              height: auto;
              line-height: inherit;
            }
          }
        }
        .el-button{
          font-size: 14px;
          border:none;
          background: none;
          padding:0;
          i{
            margin-left:5px;
          }
        }
      }
      .el-dialog__body{
        max-height: 400px;
        overflow-y: scroll;
        padding:0!important;
        .ViewMsg{
          padding:16px;
          display: flex;
          background: #FFFFFF;
          border-bottom: solid 1px #E4E8EE;
          position: relative;
          .dot{
            width: 8px;
            height:8px;
            position: absolute;
            top:8px;
            left:8px;
          }
          img{
            width:32px;
            height:32px;
          }
          .infoView{
            margin-left:16px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            p{
              font-weight: 500;
              font-size: 14px;
              line-height: 20px;
              /* or 143% */
              margin-bottom:16px;
              /* Knock/gray-900 */
              width: 312px;
              color: #1A1F36;
            }
            span{
              font-weight: normal;
              font-size: 14px;
              line-height: 20px;
              display: inline-block;
              width: 126px;
              /* identical to box height, or 143% */


              /* Knock/gray-200 */

              color: #A5ACB8;
            }
          }
        }
      }
      .el-dialog__footer{
        padding:0;
        p{
          color: #A5ACB8;
          font-size: 14px;
          height: 90px;
          line-height: 90px;
        }
        button{
          width:100%;
          height:100%;
          background: none;
          border:none;
          color: #030303;
          font-size:14px;
          margin:0;
          padding:19px 0;
          box-shadow:initial;
          font-weight: normal;
          font-family: Arial;
        }
      }
    }
    /deep/.msgdialog{
      border-radius: 16px;
      .el-dialog__header{
        width: 100%;
        height: 68px;
        background: #FF904D;
        border-radius: 16px 16px 0px 0px;
        .el-dialog__head{
          display: flex;
          height: 44px;
          align-items: center;
          justify-content: space-between;
          .el-button{
            span{
              display: flex;
              align-items: center;
              flex-direction: row;
              font-weight: normal;
              color: #fff;
            }
            span:hover{
              color: #FFF3C1;
            }
          }
        }
        .el-dialog__title{
          color: #fff !important;
          .el-select{
            background: #fff;
            margin-left: 21px;
            width: 110px;
            height: 24px;
            border-radius: 4px;
            .el-input--suffix{
              line-height: 24px;
              font-size: 14px;
              .el-input__icon{

              }
              .el-input__inner{
                padding-right: 25px;
              }
              .el-icon-arrow-up:before{
                content: '';
                background-image: url("../../assets/dowmward.png");
                width: 12px;
                height: 6px;
                //background-color: red;
                display: inline-block;
                background-size: 12px;
              }
            }
          }
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/views/header.vue